import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "likes"
}
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center comment-likes" }
const _hoisted_4 = {
  key: 2,
  class: "mt-3 comment-replies"
}
const _hoisted_5 = {
  key: 0,
  class: "comment p-12 pe-0 d-flex align-items-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_profile_picture = _resolveComponent("user-profile-picture")!
  const _component_comment_card = _resolveComponent("comment-card")!
  const _component_likes = _resolveComponent("likes")!
  const _component_new_comment_box = _resolveComponent("new-comment-box")!
  const _component_single_comment_reply = _resolveComponent("single-comment-reply")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_user_profile_picture, {
      userEmail: _ctx.comment && _ctx.comment.userid,
      cssClass: "user-icon"
    }, null, 8, ["userEmail"]),
    _createElementVNode("div", {
      class: "comment-form d-flex flex-column",
      id: _ctx.comment && _ctx.comment.id
    }, [
      _createVNode(_component_comment_card, {
        comment: _ctx.comment,
        forceShowDeleteCommentButtons: _ctx.forceShowDeleteCommentButtons,
        onCommentDeleted: _ctx.emitCommentDeleted
      }, null, 8, ["comment", "forceShowDeleteCommentButtons", "onCommentDeleted"]),
      (!_ctx.commentMarkedAsDeleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAnswerBox && _ctx.toggleAnswerBox(...args))),
                  class: "open-comment-reply-input"
                }, "Antworten")
              ]),
              _createVNode(_component_likes, {
                category: "comments",
                bundleId: _ctx.threadId,
                likedContentUuid: _ctx.comment && _ctx.comment.id,
                onLikesUpdated: _ctx.emitLikesUpdated
              }, null, 8, ["bundleId", "likedContentUuid", "onLikesUpdated"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showAnswerBox && !_ctx.commentMarkedAsDeleted)
        ? (_openBlock(), _createBlock(_component_new_comment_box, {
            key: 1,
            threadId: _ctx.threadId,
            parentThreadId: _ctx.comment && _ctx.comment.id,
            onNewComment: _ctx.emitNewCommentReply,
            focusWhenShown: true
          }, null, 8, ["threadId", "parentThreadId", "onNewComment"]))
        : _createCommentVNode("", true),
      (_ctx.comment && [_ctx.comment.replies !== undefined])
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comment.replies, (reply) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: reply.id
              }, [
                (!(reply.deleted === true))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (!(reply && reply.deleted))
                        ? (_openBlock(), _createBlock(_component_single_comment_reply, {
                            key: 0,
                            reply: reply,
                            forceShowDeleteCommentButtons: _ctx.forceShowDeleteCommentButtons,
                            onCommentDeleted: _ctx.emitCommentDeleted
                          }, null, 8, ["reply", "forceShowDeleteCommentButtons", "onCommentDeleted"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1)
  ], 64))
}